import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, defineAsyncComponent, onMounted, onUnmounted } from 'vue'

import { SysAuthProviderModule } from '@/system-modules/auth/SysAuthProvider'
import { SysLockScreenProviderModule } from '@/system-modules/lock-screen/LockScreenProvider'
import { SysWinManagerProviderModule } from '@/system-modules/win-manager/WinManagerProvider'
import { SysUpdateProviderModule } from '@/system-modules/update/SysUpdateProvider'
import { sys } from '@/system/SystemProvider'
import { readShareLinkUuid } from '@/helpers/shareLink'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const SystemIndex = defineAsyncComponent(() => import('@/system' + sys().getViewPath()))
const SystemAuth = defineAsyncComponent(() => import('@/system-modules' + SysAuthProviderModule().getViewPath()))
const SystemUpdate = defineAsyncComponent(() => import('@/system-modules' + SysUpdateProviderModule().getViewPath()))
const SystemLockScreen = defineAsyncComponent(() => import('@/system-modules' + SysLockScreenProviderModule().getViewPath()))
const SystemWinMain = defineAsyncComponent(() => import('@/system-modules' + SysWinManagerProviderModule().getMainWinPath()))
const SystemWinSupport = defineAsyncComponent(() => import('@/system-modules' + SysWinManagerProviderModule().getWidgetWinPath()))

const isAuth = computed(() => sys().auth.isAuth())
const isGuest = computed(() => sys().share.isGuest())

// использование системы — указатель мыши в области страницы: пока он там, идёт heartbeat
const onPointerEnter = () => sys().auth.startHeartbeat()
const onPointerLeave = () => sys().auth.stopHeartbeat()

onMounted(() => {
  document.documentElement.addEventListener('mouseenter', onPointerEnter)
  document.documentElement.addEventListener('mouseleave', onPointerLeave)
  // адрес ссылки share открывает страницу гостю без входа; иначе восстанавливается сеанс
  const linkUuid = readShareLinkUuid(window.location.hash)
  if (linkUuid) {
    sys().share.openGuestLink(linkUuid)
  } else {
    sys().auth.restoreSession()
  }
})

onUnmounted(() => {
  document.documentElement.removeEventListener('mouseenter', onPointerEnter)
  document.documentElement.removeEventListener('mouseleave', onPointerLeave)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(SystemUpdate)))),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(SystemLockScreen)))),
    (!isAuth.value && !isGuest.value)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(SystemAuth)), { key: 0 }))
      : _createCommentVNode("", true),
    (isAuth.value || isGuest.value)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(SystemIndex)), { key: 1 }, {
          main: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(SystemWinMain))))
          ]),
          support: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(SystemWinSupport))))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})